import { renderPrice } from '../components/tripPlanning/step2/selectedCars.js';
import { setTripData } from '../components/tripPlanning/step1/trip-form';

let departureTime = new Date();
let directionsService;
let directionsRenderer;
let distanceService;
let setFitRouteBounds;
let fromPlace = null;
let toPlace = null;
let mapKmEl = null;
let mapTimeEl = null;

let distance = null;
let distancePromiseResolve = null;

let duration = null;

export function initRouting({
  map,
  DirectionsService,
  DirectionsRenderer,
  DistanceMatrixService,
  fitRouteBounds,
}) {
  directionsService = new DirectionsService();
  directionsRenderer = new DirectionsRenderer({
    suppressMarkers: true,
    preserveViewport: true,
  });
  directionsRenderer.setMap(map);

  distanceService = new DistanceMatrixService();
  setFitRouteBounds = fitRouteBounds;

  mapKmEl = document.querySelector('.map-km');
  mapTimeEl = document.querySelector('.map-time');
}

export function setDepartureTime(time) {
  // time - рядок у форматі 'YYYY-MM-DD HH:mm'
  departureTime = new Date(time.replace(' ', 'T'));
  calculateAndDisplayRoute();
}

export function setFromForRoute(place) {
  fromPlace = place;
  calculateAndDisplayRoute();
}

export function setToForRoute(place) {
  toPlace = place;
  calculateAndDisplayRoute();
}

export function calculateAndDisplayRoute() {
  if (!fromPlace || !toPlace) return;

  directionsService.route(
    {
      origin: fromPlace.geometry.location,
      destination: toPlace.geometry.location,
      travelMode: google.maps.TravelMode.DRIVING,
      drivingOptions: {
        departureTime: departureTime, // має бути Date у майбутньому
        trafficModel: google.maps.TrafficModel.BEST_GUESS, // або 'optimistic'/'pessimistic'
      },
    },
    (result, status) => {
      if (status === google.maps.DirectionsStatus.OK) {
        directionsRenderer.setDirections(result);

        let bounds = result.routes[0].bounds;

        if (!bounds && result.routes[0].overview_path?.length) {
          bounds = result.routes[0].overview_path.reduce(
            (b, p) => (b.extend(p), b),
            new google.maps.LatLngBounds()
          );
        }

        // Вписуємо у прямокутник (зміщуємо, додаємо падінги)
        setFitRouteBounds?.(bounds);
      } else {
        console.error('Directions error:', status);
      }
    }
  );

  distanceService.getDistanceMatrix(
    {
      origins: [fromPlace.geometry.location],
      destinations: [toPlace.geometry.location],
      travelMode: google.maps.TravelMode.DRIVING,
      drivingOptions: {
        departureTime: departureTime, // має бути Date у майбутньому
        trafficModel: google.maps.TrafficModel.BEST_GUESS, // або 'optimistic'/'pessimistic'
      },
    },
    (response, status) => {
      if (status === google.maps.DistanceMatrixStatus.OK) {
        const element = response.rows[0].elements[0];
        distance = element.distance.text;
        duration = element.duration.text;

        // Значення в метрах і секундах
        const distanceValue = element.distance.value; // в метрах
        const durationValue = element.duration.value; // в секундах

        setTripData({
          distance: { value: distanceValue, text: distance },
          duration: { value: durationValue, text: duration },
        });

        // тут виклик розрахунку ціни
        renderPrice();

        // перевірити чи є секція з авто
        // оновлюємо DOM
        if (mapKmEl) mapKmEl.textContent = distance;
        if (mapTimeEl) mapTimeEl.textContent = duration;

        // повідомляємо, що distance готовий
        if (distancePromiseResolve) {
          distancePromiseResolve(distance);
          distancePromiseResolve = null;
        }
      } else {
        console.error('DistanceMatrix error:', status);
      }
    }
  );
}

export function clearFromRoute() {
  fromPlace = null;
  clearRoute();
}

export function clearToRoute() {
  toPlace = null;
  clearRoute();
}

export function clearRoute() {
  if (directionsRenderer) {
    directionsRenderer.set('directions', null);
  }

  if (mapKmEl) mapKmEl.textContent = '';
  if (mapTimeEl) mapTimeEl.textContent = '';

  distance = null;
  distancePromiseResolve = null;
}
